import "react-responsive-carousel/lib/styles/carousel.min.css";

import React, { Fragment, useCallback, useEffect, useState } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { Carousel as Lightbox } from "react-responsive-carousel";

import { setCurrentIndex, show } from "../Actions/LightboxImages.action";

const customStylesMobileModal = {
    content: {
        inset: "50% 0 -50% 0",
        background: "none",
        padding: 0,
        border: "none",
        transform: "translateY(-50%)",
        width: "100%",
        display: "flex",
        justifyContent: " center",
        flexDirection: "column",
    },
    overlay: {
        zIndex: 2003,
    },
};
const customStyles = {
    content: {
        background: "none",
        padding: 0,
        border: "none",
    },
    overlay: {
        background: "rgba(0, 0, 0, 0.8)",
        zIndex: 2003,
    },
};
const LightboxSettings = {
    showStatus: false,
    showIndicators: false,
    useKeyboardArrows: true,
    thumbWidth: 50,
    autoPlay: false,
    autoFocus: true,
};

const renderThumbnails = (children) => {
    const images = children.map((item, index) => {
        if (!item || !item.props || !item.props.children) {
            return undefined;
        }

        // find img to get source
        const imageElement = item.props.children.find(
            (ele) => ele.type === "img"
        );
        if (!imageElement || !imageElement.props || !imageElement.props.src) {
            return undefined;
        }

        return (
            <div
                key={index}
                style={{
                    backgroundImage: "url(" + imageElement.props.src + ")",
                }}
                className="thumbnail__image"
            />
        );
    });

    return images;
};

const LightboxImages = (props) => {
    const dispatch = useDispatch();
    const { visible, index } = useSelector((state) => state.lightboxImages);
    const [modalImage, setModalImage] = useState(null);
    const [showModalImage, setShowModalImage] = useState(false);
    useEffect(() => {
        // for (let i = 0; i < props.images.length; i++) {
        //     const element = props.images[i];
        //     for (const [key, value] of Object.entries(element)) {
        //         console.log(`${key}: ${value}`);
        //     }
        // }
    });
    const onClose = useCallback(() => dispatch(show(false)), [dispatch]);
    const onClickMainImage = (index) => {
        dispatch(show(true));
    };

    return !props.images || props.images.length < 1 ? (
        <Fragment />
    ) : (
        <Fragment>
            <div className="row product-images">
                <div className="small-12 large-9 large-order-1 hide-for-medium">
                    <Lightbox
                        infiniteLoop
                        showStatus={false}
                        showThumbs={false}
                    >
                        {props.images.map((image, index) => (
                            <div
                                className="product-image"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setModalImage(image.src);
                                    setShowModalImage(true);
                                }}
                                key={index}
                                // dangerouslySetInnerHTML={{
                                //     __html: image.html,
                                // }}
                            >
                                <img src={image.src} />
                            </div>
                        ))}
                    </Lightbox>
                    <Modal
                        ariaHideApp={false}
                        preventScroll={true}
                        isOpen={showModalImage}
                        onRequestClose={() => setShowModalImage(false)}
                        style={customStylesMobileModal}
                        shouldCloseOnOverlayClick={true}
                    >
                        <button
                            onClick={() => setShowModalImage(false)}
                            className="light-box__close-btn"
                        >
                            &times;
                        </button>
                        <img
                            className="light-box__img-mobile"
                            src={modalImage}
                            alt=""
                        />
                    </Modal>
                </div>
                <div className="small-12 large-9 columns large-order-1 show-for-medium">
                    <figure className="product-detail__image-container">
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                onClickMainImage(index);
                            }}
                            className="product-image"
                            // dangerouslySetInnerHTML={{
                            //     __html: props.images[index].html,
                            // }}
                        >
                            <img src={props.images[index].src} />
                        </button>
                    </figure>
                </div>
                <div className="small-12 large-3 columns medium-flex-dir-column show-for-medium">
                    <div className="row">
                        {props.images.map((image, index) => (
                            <div
                                className="product-detail__image-container columns large-12"
                                key={index}
                            >
                                <button
                                    data-src={image.src}
                                    itemProp="url"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        dispatch(setCurrentIndex(index));
                                    }}
                                    className="product-detail__image-small"
                                    dangerouslySetInnerHTML={{
                                        __html: props.images[index].html,
                                    }}
                                ></button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Modal
                ariaHideApp={false}
                preventScroll={true}
                isOpen={visible}
                onRequestClose={onClose}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
            >
                <Lightbox
                    {...LightboxSettings}
                    selectedItem={index}
                    className="light-box"
                    renderThumbs={renderThumbnails}
                >
                    {props.images.map((value, index) => (
                        <div
                            key={`figure${index}`}
                            className="light-box__container"
                        >
                            <button
                                onClick={onClose}
                                className="light-box__close-btn"
                            >
                                &times;
                            </button>
                            <img src={value.src} className="light-box__image" />
                        </div>
                    ))}
                </Lightbox>
            </Modal>
        </Fragment>
    );
};

export default LightboxImages;
